import React from 'react';
import NoValue from '../EmptyStates/NoValue';
import { numPad } from '../../Services/helpers';

const DateTime = (props) => {
    let date;
    if (props.timestamp) {
        date = new Date(props.timestamp * 1000);
    } else if (props.date) {
        let tidied = props.date.replace(' ', 'T');
        tidied = tidied.replace(/\.[0-9]{6}/, '');
        if (tidied.charAt(tidied.length - 1) !== 'Z' && tidied.indexOf('T') !== -1) {
            // tidied += 'Z';
        }
        date = new Date(tidied);

    } else if (props.week) {
        date = getDateOfISOWeek(props.week);
    } else {
        return props.blank ? <span className="text-muted">{props.blank}</span> : <NoValue />;
    }

    const hideTime = !!props.hideTime;
    const hideDay = !!props.hideDay;
    const _isToday = isToday(date);

    return <span className={props.className}>
        {props.before && props.before}
        <span className="text-capitalize">
            {_isToday && 'Today' + (hideTime ? '' : ' at ' + time(date))}
            {!_isToday && getDateStr(date, hideDay, false, props.longNames, props.showYear ?? null) + (hideTime === false ? ' at ' + time(date) : '')}
        </span>
        {props.after && props.after}
    </span>;
}

const getDateStr = (date, hideDay, hideMonth = false, longNames = false, showYear = null) => {
    if (!date) {
        return null;
    }

    let _date;
    if (typeof date === 'string') {
        _date = new Date(date);
    } else {
        _date = date;
    }

    const dStr = (d) => d.getDate() + '-' + d.getMonth() + '-' + d.getFullYear();

    const _isToday = dStr(_date) === dStr(new Date());
    if (_isToday && hideMonth) {
        return 'Today';
    }

    return [
        hideDay ? '' : dayOfWeek(_date.getDay(), longNames),
        dayOfMonth(_date.getDate()),
        hideMonth ? '' : month(_date.getMonth(), longNames, true),
        year(_date.getFullYear(), showYear)
    ].join(' ');
}

const isToday = (date) => {
    return getDateStr(date) === getDateStr(new Date())
}

const dayOfWeek = (dayOfWeek, longNames) => {
    const days = {
        short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    };

    return days[longNames ? 'long' : 'short'][dayOfWeek];
}

const dayOfMonth = (dayOfMonth) => {
    return parseInt(dayOfMonth) + nth(dayOfMonth);
}

const nth = (dayOfMonth) => {
    if (dayOfMonth > 3 && dayOfMonth < 21) {
        return 'th';
    }

    switch (dayOfMonth % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
    }
}

const month = (month, long = false, zeroBasedInput = false) => {
    const months = {
        short: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'June',
            'July',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ],
        long: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ]
    };

    const _month = zeroBasedInput ? month : month - 1;

    return months[long ? 'long' : 'short'][_month];
}

const year = (year, hideYear) => {
    if (hideYear) {
        return '';
    }
    if (hideYear === null && year === new Date().getFullYear()) {
        return null;
    }

    return year;
}

const time = (date) => {
    return numPad(date.getHours()) + ':' + numPad(date.getMinutes())
}

const getDateOfISOWeek = (str) => {
    const [y, w] = str.replace('W', '').split('-');

    var simple = new Date(y, 0, 1 + (w - 1) * 7);
    var dow = simple.getDay();
    var ISOweekStart = simple;
    if (dow <= 4)
        ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    else
        ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    return ISOweekStart;
}


export default DateTime;

export {
    month,
    getDateStr,
    dayOfMonth,
}
